

<template>
  <div style="background-color: #0A0F28;">
    <div style="width: 100%; display: flex; align-items: center; justify-content: center">
      <text style="color: #02B4FF; font-size: 28px; margin-top: 24px">无人车投放量统计看板</text>
    </div>
    <search-bar ref="searchRef" @search="doSearch" :need-sn="false" :need-time="false" :need-community="false" />
    <div class="card-container">
      <!-- 1. 完全不传参数 (使用全部默认值: 默认图标, 默认标题, 默认颜色, 默认显示--) -->
      <DashboardCard
        title="已投放数量"
        :value="transferData(cardData.putNum)"
        borderColor="#00d8ff"
      />

      <!-- 2. 还原图1：已投放无人车总量 (蓝色) -->
      <DashboardCard
        title="已投放小区"
        :value="transferData(cardData.putCommunityNum)"
        borderColor="#00d8ff"
      >
        <!-- 这里省略 icon 插槽，因为组件自带的默认图标就是车 -->
      </DashboardCard>

      <!-- 3. 还原图3：投递中数量 (绿色) -->
      <DashboardCard
        title="已投放省市区"
        :value="transferData(cardData.putProvinceNum)+ '省'+ transferData(cardData.putCityNum)+ '市'+transferData(cardData.putDistrictNum)+ '区'"
        borderColor="#00e676"
      >
        <template #icon>
          <!-- 传入自定义的 SVG 图标 (纸飞机) -->
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
        </template>
      </DashboardCard>

      <!-- 4. 还原图4：充电/待命数量 (黄色) -->
      <DashboardCard
        title="投递中数量"
        :value="transferData(deviceStatusData.deliveringNum)"
        borderColor="#ffc107"
      >
        <template #icon>
          <!-- 传入自定义的电池图标 -->
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
            <rect x="2" y="7" width="16" height="10" rx="2" ry="2"></rect>
            <line x1="22" y1="11" x2="22" y2="13"></line>
          </svg>
        </template>
      </DashboardCard>

      <!-- 5. 还原图5：离线数量 (红色) -->
      <DashboardCard
        title="充电/待命数量"
        :value="transferData(deviceStatusData.chargingStandbyNum)"
        borderColor="#ff4d4f"
      >
        <template #icon>
          <!-- 传入自定义的开关机图标 -->
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
            <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
            <line x1="12" y1="2" x2="12" y2="12"></line>
          </svg>
        </template>
      </DashboardCard>
      <DashboardCard
        title="离线数量"
        :value="transferData(deviceStatusData.offlineNum)"
        borderColor="#00d8ff"
      >
        <!-- 这里省略 icon 插槽，因为组件自带的默认图标就是车 -->
      </DashboardCard>
    </div>
    <div style="display: flex; flex-direction: row; padding: 0 24px 24px 24px">
      <div style="flex: 1;max-height: 602px">
        <MapChart ref="mapChartRef"/>
      </div>
      <div style="flex: 1; margin-left: 24px; max-height: 602px">
        <RankingList ref="rankListRef"/>
      </div>
    </div>
  </div>
</template>

<script setup>

import DashboardCard from '@/components/tdl/data/package/DashboardCard.vue'
import SearchBar from '@/components/tdl/data/package/SearchBar.vue'
import MapChart from '@/components/tdl/data/package/MapChart.vue'
import RankingList from '@/components/tdl/data/selfCar/RankingList.vue'
import { onMounted, ref } from 'vue'
import { useHostAppInstance } from '@zto/zpage'
import { formatCityName } from '@/components/tdl/data/package/utils'
const app = useHostAppInstance()
const searchRef = ref()
const mapChartRef = ref()
const rankListRef = ref()
const cardData = ref({})
const deviceStatusData = ref({})

const doSearch =  (params) => {
  console.log('===doSearch CTdlPackageData:', JSON.stringify(params))
  queryCardData(params)
  queryDeviceStatusData(params)
}
const queryDeviceStatusData = async (params) => {
  try {
    const resp = await app.request({
      api: '/sys/admin/statistics/device-put-statistics/site/device-status',
      params: params
    })
    if (resp) {
      deviceStatusData.value = resp
    }
  } catch (e) {

  }
}
const queryCardData = async (params) => {
  try {
    const resp = await app.request({
      api: '/sys/admin/statistics/device-put-statistics/overview',
      params: params
    })
    // const resp = {
    //   "reportDate": "2026-05-18",
    //   "putNum": 16,
    //   "putCommunityNum": 29,
    //   "putProvinceNum": 6,
    //   "putCityNum": 7,
    //   "putDistrictNum": 8,
    //   "list": [
    //     {
    //       "provinceCode": "31",
    //       "provinceName": "上海市",
    //       "putNum": 5,
    //       "putCommunityNum": 15
    //     },
    //     {
    //       "provinceCode": "32",
    //       "provinceName": "江苏省",
    //       "putNum": 4,
    //       "putCommunityNum": 4
    //     },
    //     {
    //       "provinceCode": "110000",
    //       "provinceName": "北京市",
    //       "putNum": 3,
    //       "putCommunityNum": 2
    //     },
    //     {
    //       "provinceCode": "13",
    //       "provinceName": "河北省",
    //       "putNum": 2,
    //       "putCommunityNum": 4
    //     },
    //     {
    //       "provinceCode": "15",
    //       "provinceName": "内蒙古自治区",
    //       "putNum": 1,
    //       "putCommunityNum": 3
    //     },
    //     {
    //       "provinceCode": "11",
    //       "provinceName": "北京市",
    //       "putNum": 1,
    //       "putCommunityNum": 1
    //     },
    //     {
    //       "provinceCode": "16",
    //       "provinceName": "山东省",
    //       "putNum": 1,
    //       "putCommunityNum": 3
    //     },
    //     {
    //       "provinceCode": "17",
    //       "provinceName": "山西省",
    //       "putNum": 1,
    //       "putCommunityNum": 1
    //     },
    //     {
    //       "provinceCode": "18",
    //       "provinceName": "河南省",
    //       "putNum": 1,
    //       "putCommunityNum": 3
    //     },
    //     {
    //       "provinceCode": "19",
    //       "provinceName": "广东省",
    //       "putNum": 1,
    //       "putCommunityNum": 1
    //     },
    //     {
    //       "provinceCode": "20",
    //       "provinceName": "宁夏",
    //       "putNum": 1,
    //       "putCommunityNum": 3
    //     },
    //     {
    //       "provinceCode": "21",
    //       "provinceName": "吉林省",
    //       "putNum": 1,
    //       "putCommunityNum": 1
    //     },
    //     {
    //       "provinceCode": "22",
    //       "provinceName": "黑龙江省",
    //       "putNum": 1,
    //       "putCommunityNum": 3
    //     },
    //     {
    //       "provinceCode": "23",
    //       "provinceName": "安徽省",
    //       "putNum": 1,
    //       "putCommunityNum": 1
    //     }
    //   ]
    // }
    if (resp) {
      cardData.value = resp
      const mapList = (resp.list || []).map((item, index)=> {
        item.name = formatCityName(item.provinceName)
        // item.name= item.provinceName
        item.value = item.putNum
        return item
      })
      mapChartRef.value.drawMap(mapList)
      rankListRef.value.setListData(mapList)
    }
  } catch (e) {

  }
}

const transferData = (num) => {
  if (typeof num === 'number') {
    return num
  }
  return '--'
}
onMounted(() => {
  searchRef.value.handleShortcut(7)
  const params = searchRef.value.getSearchParams()
  mapChartRef.value.initChart()
  doSearch(params)
});
</script>

<style scoped>
.card-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  background-color: #0a0f28; /* 页面深色底色 */
  padding: 20px;
}
</style>
